export const ACTIONS = Object.freeze({
    SET_CLIENT: Symbol("data/client"),
    SET_DATA: Symbol("data/data"),
    SET_PLANET: Symbol("data/planet"),
    SET_PLANET_STORE: Symbol("data/planetstore"),
    SET_VARIABLE: Symbol("data/variable"),
    SET_COORDINATES: Symbol("data/coord"),
    SET_HEIGHT: Symbol("data/height"),
    ADD_POI: Symbol("data/poi"),
    SET_POI: Symbol("data/pois")
});

const initialState = {
  client: null,
  data: null,
  planet: null,
  planetStore: null,
  variable: null,
  coordinates: null,
  height: null,
  poi: null
};

const handler = (state = initialState, action) => {
  
  switch (action.type) {
    case ACTIONS.SET_CLIENT: {
      return {
        ...state,
        client: action.client
      };
    }
    case ACTIONS.SET_DATA: {
      return {
        ...state,
        data: action.data
      }
    }
    case ACTIONS.SET_PLANET_STORE: {
      return {
        ...state,
        planetStore: action.planetStore
      };
    }
    case ACTIONS.SET_PLANET: {
      
      return {
        ...state,
        planet: action.planet
      };
    }

    case ACTIONS.SET_VARIABLE: {
      
      return {
        ...state,
        variable: action.variable
      };
    }

    case ACTIONS.SET_COORDINATES: {
      
      return {
        ...state,
        coordinates: action.coordinates
      };
    }

    case ACTIONS.SET_HEIGHT: {
      
      return {
        ...state,
        height: action.height
      };
    }

    case ACTIONS.ADD_POI: {
      localStorage.setItem("poi",JSON.stringify([action.poi].concat(state.poi))); 
      return {
        ...state,
        poi: [action.poi].concat(state.poi)
      };
    }

    case ACTIONS.SET_POI: {
      localStorage.setItem("poi",JSON.stringify(action.poi)); 
      
      
      return {
        ...state,
        poi: action.poi
      };
    }

    default: {
      return {
        ...state
      };
    }
  } 
};

export default handler;